export default __webpack_public_path__ + "static/media/002.3e7b447e.png";